import { supabaseClient } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { fetchI18n } from '@data';

const getI18nKey = () => ['i18n'];

export const useI18n = () => {
    return useQuery({
        queryKey: getI18nKey(),
        queryFn: () => fetchI18n(supabaseClient),
    });
};
